import { Category, Item } from '@reliance/types/models/Commissary';
import resources from '../resources';

export const CATEGORIES_LOADING = 'COMMISSARY/CATEGORIES_LOADING';
export const CATEGORIES_LOAD_SUCCESS = 'COMMISSARY/CATEGORIES_LOAD_SUCCESS';
export const CATEGORIES_LOAD_FAILED = 'COMMISSARY/CATEGORIES_LOAD_FAILED';
export function loadCategories() {
  return (dispatch) => {
    dispatch({ type: CATEGORIES_LOADING });

    return resources.commissary.category
      .index()
      .then((result) => {
        dispatch({ type: CATEGORIES_LOAD_SUCCESS, categories: result });
        return result;
      })
      .catch((err) => {
        dispatch({ type: CATEGORIES_LOAD_FAILED, error: err });
        throw err;
      });
  };
}

export const CATEGORY_VIEW = 'COMMISSARY/CATEGORY_VIEW';
export function viewCategory(category: Category) {
  return (dispatch) => {
    return new Promise<void>((resolve) => {
      dispatch({ type: CATEGORY_VIEW, category });
      resolve();
      dispatch(loadCategoryItems(category));
    });
  };
}

export function unloadCategory() {
  return { type: CATEGORY_VIEW, category: null };
}

export const CATEGORY_ITEMS_LOADING = 'COMMISSARY/CATEGORY_ITEMS_LOADING';
export const CATEGORY_ITEMS_LOAD_SUCCESS =
  'COMMISSARY/CATEGORY_ITEMS_LOAD_SUCCESS';
export const CATEGORY_ITEMS_LOAD_FAILED =
  'COMMISSARY/CATEGORY_ITEMS_LOAD_FAILED';
export function loadCategoryItems(category: Category) {
  return (dispatch) => {
    dispatch({ type: CATEGORY_ITEMS_LOADING });

    return resources.commissary.item
      .index({ categoryId: category.id })
      .then((result) => {
        dispatch({ type: CATEGORY_ITEMS_LOAD_SUCCESS, items: result });
      })
      .catch((err) => {
        dispatch({ type: CATEGORY_ITEMS_LOAD_FAILED, error: err });
        throw err;
      });
  };
}

export const CATEGORY_ADD = 'COMMISSARY/CATEGORY_ADD';
export function addCategory() {
  return { type: CATEGORY_ADD };
}

export const CATEGORY_ADD_EDIT_CANCEL = 'COMMISSARY/CATEGORY_ADD_EDIT_CANCEL';
export function cancelAddEditCategory() {
  return { type: CATEGORY_ADD_EDIT_CANCEL };
}

export const CATEGORY_EDIT = 'COMMISSARY/CATEGORY_EDIT';
export function editCategory(category: Category) {
  return { type: CATEGORY_EDIT, category };
}

export const CATEGORY_SAVING = 'COMMISSARY/CATEGORY_SAVING';
export const CATEGORY_SAVE_SUCCESS = 'COMMISSARY/CATEGORY_SAVE_SUCCESS';
export const CATEGORY_SAVE_FAILED = 'COMMISSARY/CATEGORY_SAVE_FAILED';
export function saveCategory(category: FormData) {
  return (dispatch) => {
    dispatch({ type: CATEGORY_SAVING, category });

    let promise = null;
    if (category.get('id')) {
      promise = resources.commissary.category.put(category.get('id'), category);
    } else {
      promise = resources.commissary.category.post(category);
    }

    return promise
      .then(() => dispatch({ type: CATEGORY_SAVE_SUCCESS, category }))
      .then(() => dispatch(loadCategories()))
      .catch((error) => dispatch({ type: CATEGORY_SAVE_FAILED, error }));
  };
}

export const ITEM_ADD = 'COMMISSARY/ITEM_ADD';
export function addItem() {
  return { type: ITEM_ADD };
}

export const ITEM_ADD_EDIT_CANCEL = 'COMMISSARY/ITEM_ADD_EDIT_CANCEL';
export function cancelAddEditItem() {
  return { type: ITEM_ADD_EDIT_CANCEL };
}

export const ITEM_EDIT = 'COMMISSARY/ITEM_EDIT';
export function editItem(item: Item) {
  return { type: ITEM_EDIT, item };
}

export const ITEM_SAVING = 'COMMISSARY/ITEM_SAVING';
export const ITEM_SAVE_SUCCESS = 'COMMISSARY/ITEM_SAVE_SUCCESS';
export const ITEM_SAVE_FAILED = 'COMMISSARY/ITEM_SAVE_FAILED';
export function saveItem(category: Category, item: FormData) {
  return (dispatch) => {
    dispatch({ type: ITEM_SAVING, item, category });

    let promise = null;
    if (item.get('id')) {
      promise = resources.commissary.item.put(item.get('id'), item);
    } else {
      item.set('categoryIds', category.id.toString());
      promise = resources.commissary.item.post(item);
    }

    return promise
      .then(() => dispatch({ type: ITEM_SAVE_SUCCESS, item }))
      .then(() => dispatch(loadCategoryItems(category)))
      .catch((error) => dispatch({ type: ITEM_SAVE_FAILED, error }));
  };
}

export const ORDERS_LOADING = 'COMMISSARY/ORDERS_LOADING';
export const ORDERS_LOAD_SUCCESS = 'COMMISSARY/ORDERS_LOAD_SUCCESS';
export const ORDERS_LOAD_FAILED = 'COMMISSARY/ORDERS_LOAD_FAILED';
export function loadOrders(page = 1, perPage = 100) {
  return (dispatch) => {
    dispatch({ type: ORDERS_LOADING });

    return resources.commissary.order
      .index({ page, perPage })
      .then((result) => {
        dispatch({ type: ORDERS_LOAD_SUCCESS, orders: result });
        return result;
      })
      .catch((err) => {
        dispatch({ type: ORDERS_LOAD_FAILED, error: err });
        throw err;
      });
  };
}

export const CHANGE_PAGE = 'COMMISSARY/CHANGE_PAGE';
export function changePage(page) {
  return (dispatch, getState) => {
    dispatch({ type: CHANGE_PAGE, page });

    const state = getState();
    dispatch(
      loadOrders(state.commissary.orders.page, state.commissary.orders.perPage)
    );
  };
}

export const CHANGE_PER_PAGE = 'COMMISSARY/CHANGE_PER_PAGE';
export function changePerPage(perPage) {
  return (dispatch, getState) => {
    dispatch({ type: CHANGE_PER_PAGE, perPage });

    const state = getState();
    dispatch(
      loadOrders(state.commissary.orders.page, state.commissary.orders.perPage)
    );
  };
}

export const ORDER_LOADING = 'COMMISSARY/ORDER_LOADING';
export const ORDER_LOAD_SUCCESS = 'COMMISSARY/ORDER_LOAD_SUCCESS';
export const ORDER_LOAD_FAILED = 'COMMISSARY/ORDER_LOAD_FAILED';
export function loadOrder(id: number) {
  return (dispatch) => {
    dispatch({ type: ORDER_LOADING, id });

    return resources.commissary.order
      .get(id)
      .then((order) => {
        dispatch({ type: ORDER_LOAD_SUCCESS, order });
      })
      .catch((err) => {
        dispatch({ type: ORDER_LOAD_FAILED, error: err });
        throw err;
      });
  };
}
